<div class="header">
  <rb-header [eutrDocument]="eutrDocumentService.getEutrDocument()"></rb-header>
</div>
<div class="content">
  <router-outlet></router-outlet>
</div>
